export const SORT_COPY_EQUIVALENT: Record<number, string> = {
  1: 'default',
  2: 'minorToMajorPrice',
  3: 'majorToMinorPrice',
  4: 'minorToMajorName',
  5: 'majorToMinorName',
  6: 'minorToMajorPricePerSubUnit',
  7: 'majorToMinorPricePerSubUnit',
  8: 'minorToMajorExternalCreationDate',
  9: 'majorToMinorExternalCreationDate',
  10: 'minorToMajorPromotionActive',
}
